import styled from 'styled-components';

const FooterWrapperStyled = styled.footer.attrs({
	'data-at': 'footer-wrapper'
})`
	background: var(--footer-bg, rgba(var(--base-10), 1));
	grid-area: footer;
`;

const FooterWrapper = props => {
	return <FooterWrapperStyled {...props} />;
};

export default FooterWrapper;
